
import mixins from "vue-typed-mixins";
import Common from "@/mixins/Common";
import QuestWrapperComponent from "../../components/QuestWrapperComponent.vue";
import { QuestViewModel } from "@/interfaces/QuestViewModel";
import { PropType } from "vue";
import confetti from "canvas-confetti";
import { mapMutations, mapGetters } from "vuex";
import { PatientPortalRxContainer } from "@/interfaces/PatientPortalRxContainer";
import { AjaxReturnViewModel } from "@/interfaces/AjaxReturnViewModel";
import store from "@/store";
import swal from "sweetalert";

export default mixins(Common).extend({
  mixins: [Common],
  name: "visit-complete",
  props: {
    q: Object as PropType<QuestViewModel>,
    isAfterCheckout: { default: false, type: Boolean },
    hasQuestions: { default: true, type: Boolean },
  },
  data() {
    return {
      isLogoShown: true as boolean,
      waitForVisitLink: false as boolean,
      waitForVisitLinkRetry: 0 as number,
    };
  },
  mounted() {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });
    setTimeout(() => {
      this.isLogoShown = false;
    }, 1900);
  },
  computed: {
    ...mapGetters({
      Loading: "getLoading",
      Content: "getContent",
      QuestType: "getCurrentQuestType",
      Lang: "getLang",
    }),
    // completeText() {
    //   const defaultText = "Default text when VisitCompleteText is not available";
    //   if (this.q.visitRequired || this.q.noDrReview) {
    //     return "Be sure to check your email for updates.";
    //   } else {
    //     return (this.Content.VisitCompleteText as string) || defaultText;
    //   }
    // },
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
    }),
    async go_external(questionnaireTypeID: number) {
      if (this.waitForVisitLinkRetry >= 60) {
        swal({
          title: "Error",
          text: "Failed to retrieve the visit link after multiple attempts. Please try again later.",
          icon: "error",
        });
        this.waitForVisitLink = false;
        this.waitForVisitLinkRetry = 0;
        return;
      }
      this.waitForVisitLinkRetry += 1;
      this.waitForVisitLink = true;
      var tResult: AjaxReturnViewModel<string> = await store.dispatch("GetTelegraVisitURL", { questionnaireTypeID: questionnaireTypeID });
      console.log("Telegra visit URL result:", tResult);
      if (!tResult || !tResult.success || !tResult.data) {
        window.setTimeout(() => {
          this.go_external(questionnaireTypeID);
        }, 5000);
        return;
      }
      window.open(tResult.data, "_blank");
      this.waitForVisitLink = false;
      this.next_click();
    },
    next_click() {
      this.setLoading(true);
      this.$emit("saveandnavigate", "+");

      setTimeout(() => {
        this.setLoading(false);
      }, 3000);
    },
  },
  components: { QuestWrapperComponent },
});
